export const sortingOptions = [
  { title: 'Last modified', value: 'last_modified' },
  { title: 'Last created', value: 'last_created' },
  { title: 'Alphabetically', value: 'alphabetically' }
]

export const projectSortingOptions = [
  { title: 'Last opened', value: 'last_opened' },
  { title: 'Alphabetically', value: 'alphabetically' }
]

export const filteringOptions = [
  { title: 'Owned by anyone', value: 'owned_by_anyone' },
  { title: 'Owned by me', value: 'owned_by_me' },
  { title: 'Not owned by me', value: 'not_owned_by_me' }
]

export const customFieldExampleData = [
  {
    name: 'NEW FIELD 1',
    exampleData: ['Example 1']
  }
]

export const customerExampleData = [
  {
    name: 'Customer ID',
    exampleData: ['CUST001', 'CUST002', 'CUST003']
  }, {
    name: 'First Name',
    exampleData: ['Alice', 'Mark', 'Sarah']
  }, {
    name: 'Last Name',
    exampleData: ['Johnson', 'Chen', 'Lee']
  }, {
    name: 'Email',
    exampleData: ['alice.johnson@email.com', 'mark.chen@email.com', 'sarah.lee@email.com']
  }, {
    name: 'Phone Number',
    exampleData: ['+1-514-123-4567', '+1-438-765-4321', '+1-647-789-3210']
  }, {
    name: 'Company Name',
    exampleData: ['Johnson Supplies Inc', 'ChenTech', 'Lee Design Studio']
  }
]

export const productExampleData = [
  {
    name: 'Product ID',
    exampleData: ['PROD1001', 'PROD1002', 'PROD1003']
  }, {
    name: 'Product Name',
    exampleData: ['Ergonomic Chair', 'Wireless Mouse', 'Standing Desk']
  }, {
    name: 'Description',
    exampleData: [
      'Comfortable office chair',
      'Bluetooth-enabled wireless mouse',
      'Adjustable height desk'
    ]
  }, {
    name: 'SKU',
    exampleData: ['CHR-ERG-01', 'MSE-WLS-02', 'DSK-STND-03']
  }, {
    name: 'Category',
    exampleData: ['Office Furniture', 'Electronics', 'Office Furniture']
  }, {
    name: 'Price',
    exampleData: [149.99, 29.99, 299.99]
  }
]

export const orderExampleData = [
  {
    name: 'Order ID',
    exampleData: ['ORD001', 'ORD002', 'ORD003']
  }, {
    name: 'Order Number',
    exampleData: ['100001', '100002', '100003']
  }, {
    name: 'Customer ID',
    exampleData: ['CUST001', 'CUST003', 'CUST002']
  }, {
    name: 'Order Date',
    exampleData: ['2025-03-20', '2025-03-21', '2025-03-22']
  }, {
    name: 'Order Status',
    exampleData: ['Shipped', 'Pending', 'Delivered']
  }, {
    name: 'Order Rows',
    exampleData: [
      '[{ProductID: "PROD1001", Quantity: 2}, {ProductID: "PROD1002", Quantity: 1}]',
      '[{ProductID: "PROD1003", Quantity: 1}]',
      '[{ProductID: "PROD1001", Quantity: 1}, {ProductID: "PROD1002", Quantity: 2}]'
    ]
  }
]

export const DataFieldType = Object.freeze({
  NORMAL: '',
  FILTER: 'filter'
})
